"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRApplicationLocale = void 0;
class XHRApplicationLocale {
    constructor(locale) {
        this.name = this.constructor.name;
        this.locale = locale;
    }
    async handleRequest(request) {
        request.headers = {
            ...request.headers,
            applicationlocale: this.locale.getLocale(),
        };
        return Promise.resolve(request);
    }
}
exports.XHRApplicationLocale = XHRApplicationLocale;
//# sourceMappingURL=xhrApplicationLocale.js.map